import { useCallback, useState } from "react";

type SetValue<T> = (value: T | ((prevState: T) => T)) => void;

export function useLocalStorage<T>(key: string, initialValue: T): [T, SetValue<T>] {
    const [storedValue, setStoredValue] = useState<T>(() => {
        try {
            const item = window.localStorage.getItem(key);
            if (item && item !== "undefined") {
                return JSON.parse(item);
            } else {
                if (initialValue !== null && initialValue !== undefined) {
                    window.localStorage.setItem(key, JSON.stringify(initialValue));
                }
                return initialValue as T;
            }
        } catch (error) {
            console.error(error);
            return initialValue as T;
        }
    });

    const setValue: SetValue<T> = useCallback(
        value => {
            try {
                const valueToStore = value instanceof Function ? value(storedValue) : value;
                setStoredValue(valueToStore);
                window.localStorage.setItem(key, JSON.stringify(valueToStore));
            } catch (error) {
                console.error(error);
            }
        },
        [key, storedValue]
    );

    return [storedValue, setValue];
}
